"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TextUtils = /** @class */ (function () {
    function TextUtils() {
    }
    TextUtils.camelCasedSlugify = function (str) {
        return str.toLowerCase()
            .replace(/[^\w\d\s\-]+/g, "")
            .replace(/_+|-+/g, " ")
            .replace(/^[\s|\-]+|[\s|\-]+$/, "")
            .replace(/(\s+.)/g, function (match, group) { return group.toUpperCase().trim(); });
    };
    return TextUtils;
}());
exports.TextUtils = TextUtils;
;
